import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';
import { __require as requireIsCallable } from './node_modules-core-js-internals-is-callable.js';

var getBuiltIn;
var hasRequiredGetBuiltIn;

function requireGetBuiltIn () {
	if (hasRequiredGetBuiltIn) return getBuiltIn;
	hasRequiredGetBuiltIn = 1;
	var globalThis = requireGlobalThis();
	var isCallable = requireIsCallable();

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};

	getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
	};
	return getBuiltIn;
}

export { requireGetBuiltIn as __require };
//# sourceMappingURL=node_modules-core-js-internals-get-built-in.js.map
